import useCapabilities, { DOMAIN, PERMISSION, useHasCapabilityBool } from "@/hooks/useCapabilities";
import { Navigate, useParams } from "react-router-dom";

export default function PersonBillingPage() {
  const { pgaId } = useParams();
  const { loaded } = useCapabilities();
  const canViewOrders = useHasCapabilityBool({
    domain: DOMAIN.COMMERCE,
    permission: PERMISSION.viewOrders
  });
  const canViewPersonBilling = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonBilling
  });

  if (!pgaId) return null;
  if (!loaded) return null;

  if (canViewOrders) {
    return <Navigate to={`/people/${pgaId}/billing/orders`} replace />;
  }

  if (canViewPersonBilling) {
    return <Navigate to={`/people/${pgaId}/billing/payout-profiles`} replace />;
  }

  return <Navigate to={`/people/${pgaId}/person/overview`} replace />;
}
